export default __webpack_public_path__ + "static/media/MS-Sans-Serif.82eeac7b.woff";